import { render, staticRenderFns } from "./results-test-end.vue?vue&type=template&id=6172c6f5&scoped=true&"
import script from "./results-test-end.vue?vue&type=script&lang=js&"
export * from "./results-test-end.vue?vue&type=script&lang=js&"
import style0 from "./results-test-end.vue?vue&type=style&index=0&id=6172c6f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6172c6f5",
  null
  
)

export default component.exports